/*
  * 语言包VueI18n组件
*/

import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { setLang, getLang } from './storage'

Vue.use(VueI18n)

const DEFAULT_LANG = 'zh'
const locales = {
  zh: require('./zh.json'),
  en: require('./en.json')
}
let lang = getLang()
if (!lang) {
  setLang(DEFAULT_LANG)
  lang = getLang()
}
// Vue.config.lang = lang
let i18n = new VueI18n({
  locale: lang,
  messages: locales
})

document.body.setAttribute('lang', lang)
window.i18n = i18n

export default i18n
